import { request } from '@/utils/request'
import { cookies } from '@/utils/cookies'

export const reqDriverLocations = () => request.get('driver/all-location')

export const reqDriverOptions = () =>
  request.get(`driver/list/?code=${cookies.get('GladTeamCode')}&task=general`)

export const reqDriverInfo = (params) => request.get('driver/info', { params })

export const reqDispatch = (name) =>
  request.get(`dispatch-area/info?search=name&name=${name}`)

export const reqShift = (name) =>
  request.get(`shift-area/info?search=name&name=${name}`)

/* 此api平均回覆為7s，若前一次的請求尚未有回覆，須cancel request */
export const reqAddress = (lng, lat, cancel) =>
  request.get(`service/address/near/?points=${lng},${lat}`, cancel)

export const reqSimilarAddress = (params) =>
  request.get(`searchSimilarAddress`, { params })

export const reqIntersection = (params) =>
  request.get('intersectionInfo', { params })

export const reqDbAddress = (params) =>
  request.get(`search/address/v2`, { params })

export const reqGoogleAddress = (address) =>
  request.get(`google/find_address?address=${address}`)



// WEBPACK FOOTER //
// ./src/api/driverMonitor/index.js